import { getRequest, patchRequest, postRequest } from '@react/helpers/fetch'

const withParams = (path, params) => {
  const url = new URL(window.location.origin + path)
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) url.searchParams.set(key, value)
  })
  return url.pathname + url.search
}

export const fetchIssues = (issuesPath) => getRequest(issuesPath)

export const fetchIssue = (issuePath, number) =>
  getRequest(withParams(issuePath, { number }))

export const checkPoint = (checkPath, { number, point, checked }) =>
  patchRequest({ url: checkPath, body: { number, index: point.index, label: point.label, checked } })

export const postComment = (commentPath, { number, body }) =>
  postRequest({ url: commentPath, body: { number, body } })

export const fetchPromoted = (promotedPath) => getRequest(promotedPath)

export const setTestsStatus = (statusPath, { number, state }) =>
  patchRequest({ url: statusPath, body: { number, state } })

export const fileLinks = (filesPath, signedIds) =>
  postRequest({ url: filesPath, body: { signed_ids: signedIds } })
